import type { ContractHandlers } from '@cognitoforms/builder-types';
import type { LegacyHandlers } from '../legacy-mirrored-builder';
import { findLegacyField, type LegacyForm } from '../legacy-form';
import { mirrorAllowedSigners } from './fields/signature/legacy-allowed-signers';

type FieldHandlers = Pick<LegacyHandlers, 'createField' | 'updateField' | 'deleteField' | 'reorderField'>;
type UpdateFieldArgs = Parameters<ContractHandlers['updateField']>[1];

const findField = (legacyForm: LegacyForm, parentFieldSetId: string, index: number): any => {
	const field = findLegacyField(legacyForm, parentFieldSetId, index);
	if (!field)
		throw new Error('Field not found');
	return field;
};

export const createLegacyFieldHandlers = (): FieldHandlers => ({
	updateField: (legacyForm: LegacyForm, parentFieldSetId: string, args: UpdateFieldArgs) => {
		if ('AllowedSigners' in args && args.AllowedSigners)
			mirrorAllowedSigners(legacyForm, parentFieldSetId, args.Index, args.AllowedSigners);

		const field = findField(legacyForm, parentFieldSetId, args.Index);
		if (args.Required === 'true')
			field.set_isRequired('Always');
		else if (args.Required === 'false')
			field.set_isRequired('Never');
		else if (args.Required !== undefined)
			field.set_Required(args.Required);
		if ('Quantity' in args) {
			if (args.Quantity === '1')
				field.set_limitQuantities('No Duplicates');
		}
		if ('QuantityError' in args)
			field.set_QuantityError(args.QuantityError);
	}
});
